import React from "react";
import ReactTooltip from "react-tooltip";

export const GlossaryTooltip = () => {
    return (
        <ReactTooltip
            id="glossary"
            place="top"
            type="dark"
            effect="solid"
            className="rc-tooltip-custom-class"
            backgroundColor="#007bff"
            delayShow={500}
            getContent={dataTip => (
                <span>
                    <i className="fas fa-info-circle" style={{ marginRight: "5px" }}></i>
                    {dataTip}
                </span>
            )}
        />
    );
};

export const rebuildGlossaryTooltip = () => {
    ReactTooltip.rebuild();
};
